export const breadcrumb = {
  notification: {
    title: 'Notifikasi'
  }
};
